import { Directive, ElementRef, OnDestroy } from '@angular/core';

// Makes the forms rendered inside the host read-only, for the reader preview:
// - every <form> gets the `inert` attribute (no typing, focus, clicks or map picking), also for forms
//   that are rendered later when the document changes
// - submit events are stopped in the capture phase, before they reach the form's own (ngSubmit) listener
@Directive({
  selector: '[appPreviewNoSubmit]',
  standalone: true,
})
export class PreviewNoSubmitDirective implements OnDestroy {
  private readonly element: HTMLElement;
  private readonly observer: MutationObserver;

  private readonly block = (event: Event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  constructor(host: ElementRef<HTMLElement>) {
    this.element = host.nativeElement;
    this.element.addEventListener('submit', this.block, true);

    this.observer = new MutationObserver(() => this.makeFormsInert());
    this.observer.observe(this.element, { childList: true, subtree: true });
    this.makeFormsInert();
  }

  private makeFormsInert(): void {
    this.element.querySelectorAll('form:not([inert])').forEach(form => form.setAttribute('inert', ''));
  }

  ngOnDestroy(): void {
    this.element.removeEventListener('submit', this.block, true);
    this.observer.disconnect();
  }
}
